import { MarketingPage, SiteConfig } from '../../types';
import { doc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { safeWrite, uploadImage } from './coreService';

export const fetchMarketingPages = async (firestore: any): Promise<MarketingPage[]> => {
  const snap = await getDocs(collection(firestore, 'marketing_pages'));
  return snap.docs.map(d => d.data() as MarketingPage);
};

export const addMarketingPage = async (firestore: any, pages: MarketingPage[], page: MarketingPage) => {
  pages.push(page);
  await safeWrite(doc(firestore, 'marketing_pages', page.id), page);
};

export const updateMarketingPage = async (
  firestore: any, 
  storage: any, 
  pages: MarketingPage[], 
  page: MarketingPage
) => {
  const updatedComponents = await Promise.all(page.components.map(async (comp: any) => {
    if (comp.content?.imageUrl && comp.content.imageUrl.startsWith('data:')) {
      comp.content.imageUrl = await uploadImage(storage, comp.content.imageUrl, `marketing/${page.id}/${comp.id}`);
    }
    return comp;
  }));
  
  const pageToSave = { ...page, components: updatedComponents, updatedAt: new Date() };
  
  // Update in-place in the array reference passed (simulating cache update in facade)
  // or return the new array to be set by the caller. 
  // For better purity, let's return the new page and let basic facade handle logic, 
  // but to match logic of push, the caller will need to handle array update.
  
  await safeWrite(doc(firestore, 'marketing_pages', page.id), pageToSave);
  return pageToSave;
};

export const removeMarketingPage = async (firestore: any, id: string) => {
  await deleteDoc(doc(firestore, 'marketing_pages', id));
};

export const getBuilderPage = (id: string, marketingPages: MarketingPage[], siteConfig: SiteConfig | null): MarketingPage | undefined => {
    // 1. Marketing
    const marketingPage = marketingPages.find(p => p.id === id);
    if (marketingPage) return marketingPage;

    // 2. Custom (Legacy + Builder)
    const customPage = siteConfig?.customPages?.find((p: any) => p.id === id);
    if (customPage) {
       return {
          id: customPage.id,
          title: customPage.title,
          slug: customPage.slug,
          description: '',
          type: 'marketing',
          isPublished: true,
          isActive: true,
          requireAuth: false,
          views: 0,
          conversions: 0,
          components: customPage.components || [],
          createdAt: new Date(),
          updatedAt: new Date(),
          createdBy: 'system',
          theme: { primaryColor: '#000', secondaryColor: '#fff', fontFamily: 'Inter', borderRadius: '4px' }
       } as MarketingPage;
    }
    return undefined;
};
